import {
  forwardRef,
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
} from "react";
import TableBody from "./TableBody";
import TableHead from "./TableHead";
import { Table } from "react-bootstrap";
import { useSortableTable } from "hooks/useSortableTable";
import useStickyHeader from "hooks/useStickyHeader";

const DeviceListTable = forwardRef(
  (
    {
      data,
      columns,
      currentPage,
      pageLimit,
      isOrgLevel,
      deviceListFetch,
      filterData,
      setDeleteBtnDisable,
      setParentCheckedIDs,
      isManagerPrivilege,
    },
    ref
  ) => {
    const [tableData, handleSorting] = useSortableTable(data, columns);
    const { tableRef, stickyStyle } = useStickyHeader();
    const [checkedAll, setCheckedAll] = useState(false);
    const [checkedRows, setCheckedRows] = useState(
      Array(pageLimit).fill(false) // for msp data is page only, need total number
    );
    const [checkedIDs, setCheckedIDs] = useState([]);

    useImperativeHandle(ref, () => ({
      resetCheckBox() {
        setCheckedIDs([]);
        setCheckedAll(false);
        setCheckedRows(Array(pageLimit).fill(false));
      },
    }));

    useEffect(() => {
      setCheckedAll(false);
      setCheckedRows(Array(pageLimit).fill(false));
      setParentCheckedIDs([]);
      setDeleteBtnDisable(true);
    }, [currentPage, pageLimit]);

    const handleCheckAll = (DeviceIDs) => {
      const checkAllStatus = !checkedAll;
      setCheckedAll(checkAllStatus);
      setDeleteBtnDisable(!checkAllStatus);
      setCheckedRows(checkedRows.map(() => checkAllStatus));
      if (checkAllStatus) {
        setCheckedIDs(DeviceIDs);
        setParentCheckedIDs(DeviceIDs);
      } else {
        setCheckedIDs([]);
        setParentCheckedIDs([]);
      }
    };
    const handleCheck = (index, id, checkBoxCount) => {
      let newRows = [...checkedRows];
      newRows[index] = !newRows[index];
      if (newRows[index]) {
        // append checkbox id
        setCheckedIDs([...checkedIDs, id]);
        setParentCheckedIDs([...checkedIDs, id]);
      } else {
        // remove checkbox id
        setCheckedIDs((checkedIDs) => checkedIDs.filter((item) => item !== id));
        setParentCheckedIDs((checkedIDs) =>
          checkedIDs.filter((item) => item !== id)
        );
      }
      setCheckedRows(newRows);
      const checkedRowsRange = newRows.slice(0, checkBoxCount);
      setDeleteBtnDisable(!checkedRowsRange.some((r) => r));
      setCheckedAll(
        checkedRowsRange.length > 0 && checkedRowsRange.every((r) => r)
      );
    };
    const fetchDeviceListTriggerByHeader = useCallback(
      (sort, reverse) => {
        deviceListFetch(
          pageLimit,
          (currentPage - 1) * pageLimit,
          sort,
          reverse,
          isOrgLevel,
          filterData
        );
      },
      [currentPage, pageLimit, deviceListFetch, isOrgLevel, filterData]
    );

    return (
      <>
        <Table responsive striped className="table-container" ref={tableRef}>
          <TableHead
            {...{
              columns,
              tableData,
              handleSorting,
              currentPage,
              pageLimit,
              stickyStyle,
              fetchDeviceListTriggerByHeader,
              isOrgLevel,
              handleCheckAll,
              checkedAll,
              isManagerPrivilege,
            }}
          />
          <TableBody
            {...{
              columns,
              tableData,
              currentPage,
              pageLimit,
              isOrgLevel,
              checkedRows,
              handleCheck,
              isManagerPrivilege,
            }}
          />
        </Table>
      </>
    );
  }
);

export default DeviceListTable;
